<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="calculator-wrapper white">
            <h2 class="title text-center">減碳計算機-住</h2>
        </div>
        <!-- 題目組件 -->
        <Calculator :title="title" :subtitle="subtitle" :options="options" @get-result="getResult" v-show="!showResult" />
        <!-- 計算結果 CalculatorLivingResult -->
        <div v-if="result === '1' && showResult">
            <CalculatorLivingResult :count="10" :earth="earth[0]" :year="Math.floor(earth[0] * 52 * 100) / 100"
                @show-question="showQuestion" />
        </div>
        <div v-if="result === '2' && showResult">
            <CalculatorLivingResult :count="15" :earth="earth[1]" :year="Math.floor(earth[1] * 52 * 100) / 100"
                @show-question="showQuestion" />
        </div>
        <div v-if="result === '3' && showResult">
            <CalculatorLivingResult :count="20" :earth="earth[2]" :year="Math.floor(earth[2] * 52 * 100) / 100"
                @show-question="showQuestion" />
        </div>
        <div v-if="result === '4' && showResult">
            <CalculatorLivingResult :count="30" :earth="earth[3]" :year="Math.floor(earth[3] * 52 * 100) / 100"
                @show-question="showQuestion" />
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import Calculator from '@/components/Calculator';
import CalculatorLivingResult from '@/components/CalculatorLivingResult';

export default {
    data() {
        return {
            result: '',
            showResult: false,
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            title: '你願意一週減少開冷氣幾個小時？',
            subtitle: '',
            earth: [
                4.95, 7.425, 9.9, 14.85,
            ],
            options: [
                {
                    id: 1,
                    val: '1',
                    title: '減少10個小時',
                },
                {
                    id: 2,
                    val: '2',
                    title: '減少15個小時',
                },
                {
                    id: 3,
                    val: '3',
                    title: '減少20個小時',
                },
                {
                    id: 4,
                    val: '4',
                    title: '減少30個小時',
                },
            ],
        };
    },
    components: {
        Banner,
        Breadcrumb,
        Calculator,
        CalculatorLivingResult,
    },
    methods: {
        getResult(val) {
            if (val) {
                this.result = val;
                this.showResult = true;
            }
        },
        showQuestion(val) {
            this.showResult = val;
        },
    },
    mixins: [coreMixin],
};
</script>

<style scoped>
.optStyle {
    background-color: #B1DEF3;
    box-shadow: 5px 5px 10px rgb(99, 99, 99, 0.2);
    width: 300px;
    padding: 12px 24px;
    border-radius: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
}

input[type="radio"] {
    width: 30px;
    height: 30px;
    -webkit-appearance: none;
    /* 移除默认样式 */
    appearance: none;
    /* 其他浏览器支持的移除默认样式 */
    border-radius: 50%;
    outline: none;
    box-shadow: 5px 5px 8px rgb(99, 99, 99, 0.2);
    background-color: rgb(255, 255, 255, 0.6);
    position: relative;
    margin-right: 32px;
}

input[type="radio"]::after {
    content: '';
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #666666;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
}

input[type="radio"]:checked::after {
    opacity: 1;
}
</style>
